import { accountingApi } from '../../../../config/apiClient';

// Image Service Base URL - .env dosyasından al
const IMAGE_SERVICE_URL = process.env.REACT_APP_IMAGESERVICE_URL || 'http://localhost:5170';

export interface UploadedImageResponse {
  originalUrl: string;
  thumbnailUrl: string;
  deleteToken: string; // Guid (resim silme için)
  mediaType?: string;
}

export const ImageUploadService = {
  /**
   * Resimleri Image Service'e yükle
   * @param files - Yüklenecek dosyalar
   * @returns Upload edilen resimlerin URL'leri ve delete token'ları
   */
  async uploadImages(files: File[]): Promise<UploadedImageResponse[]> {
    const formData = new FormData();
    
    // Tüm dosyaları FormData'ya ekle
    files.forEach(file => {
      formData.append('files', file);
    });

    console.log('📤 [IMAGE UPLOAD] Resimler yükleniyor...');
    console.log('📤 [IMAGE UPLOAD] URL:', IMAGE_SERVICE_URL);
    console.log('📤 [IMAGE UPLOAD] Dosya sayısı:', files.length);
    console.log('📤 [IMAGE UPLOAD] FormData içeriği:', Array.from(formData.entries()));

    try {
      const response = await accountingApi.post<UploadedImageResponse[]>(
        `${IMAGE_SERVICE_URL}/api/Images`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 60000, // 60 saniye timeout
        }
      );

      console.log('✅ [IMAGE UPLOAD] Başarılı! Response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('❌ [IMAGE UPLOAD] Hata detayı:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config,
      });
      
      // 503 Service Unavailable hatası için özel mesaj
      if (error.response?.status === 503) {
        throw new Error('Resim servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.');
      }
      
      throw new Error(error.response?.data?.message || error.response?.data || 'Resim yüklenirken bir hata oluştu');
    }
  },

  /**
   * Videoları Image Service'e yükle
   */
  async uploadVideos(files: File[]): Promise<UploadedImageResponse[]> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    try {
      const response = await accountingApi.post<UploadedImageResponse[]>(
        `${IMAGE_SERVICE_URL}/api/Images`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 300000,
        }
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 503) {
        throw new Error('Medya servisi şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.');
      }
      throw new Error(error.response?.data?.message || error.response?.data || 'Video yüklenirken bir hata oluştu');
    }
  },

  /**
   * Image Service'den resim sil
   * @param deleteToken - Silme token'ı (Guid)
   */
  async deleteImage(deleteToken: string): Promise<void> {
    try {
      await accountingApi.post(`${IMAGE_SERVICE_URL}/api/Images/delete`, {
        token: deleteToken,
      });

      console.log('✅ Resim Image Service\'den silindi:', deleteToken);
    } catch (error: any) {
      console.error('❌ Resim silme hatası:', error);
      throw new Error(error.response?.data || 'Resim silinirken bir hata oluştu');
    }
  },
};

